import { useCallback, useEffect } from 'react';

const ESCAPE_KEY = 'Escape';

/**
 * This hook takes in a callback to execute when escape key is pressed
 * @param {function} callback - Callback function to execute when escape key is triggered
 * @param {array} dependencies - Dependencies for the hook (e.g. ref)
*/

export const useEscape = (callback, dependencies) => {
  const handleEscape = useCallback((event) => {
    if (event.key === ESCAPE_KEY) {
      callback(event);
    }
  }, [callback]);

  useEffect(() => {
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps -- Ignore
  }, [handleEscape, ...dependencies]);
};
